module.exports = __webpack_public_path__ + "media/img/decentral-illustration-0655440f668f93f51bc9cc3d78c729ff.svg";